const type = 'DISMISS_TOAST';

const dismissToast = () => ({
  type,
});

export { type };
export default dismissToast;
